export const formatPhoneNumber = (phoneNumber) => {
  if (!phoneNumber || typeof phoneNumber !== 'string') return '';

  // Extract prefix, number, and suffix using regex
  const match = phoneNumber.match(/^(\D*?)([0-9+]+)(\D*)$/);
  if (!match) return phoneNumber; // Return original if no match

  const [, prefix, digits, suffix] = match;

  if (!digits) return phoneNumber; // Return original if no digits

  // Process digits
  let hasPlus = digits.startsWith('+');
  let cleanDigits = digits;
  if (hasPlus) {
    cleanDigits = digits.slice(1);
  }
  cleanDigits = cleanDigits.replace(/\D/g, ''); // Remove any remaining non-digits
  if (cleanDigits.length === 0) return phoneNumber;

  // Format digits: group from the end
  const parts = [];
  let remaining = cleanDigits;

  // Last 3 digits
  if (remaining.length >= 3) {
    parts.unshift(remaining.slice(-3));
    remaining = remaining.slice(0, -3);
  } else {
    parts.unshift(remaining);
    remaining = '';
  }

  // Next 3 digits
  if (remaining.length >= 3) {
    parts.unshift(remaining.slice(-3));
    remaining = remaining.slice(0, -3);
  } else if (remaining.length > 0) {
    parts.unshift(remaining);
    remaining = '';
  }

  // Next 4 digits
  if (remaining.length >= 4) {
    parts.unshift(remaining.slice(-4));
    remaining = remaining.slice(0, -4);
  } else if (remaining.length > 0) {
    parts.unshift(remaining);
    remaining = '';
  }

  // Any remaining digits
  if (remaining.length > 0) {
    parts.unshift(remaining);
  }

  // Join with hyphens and prepend '+' if it was present
  const formattedNumber = parts.join('-');
  const formattedDigits = hasPlus ? `+${formattedNumber}` : formattedNumber;

  // Reattach prefix and suffix
  return `${formattedDigits}`;
};